// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"c7fdbfa2","253":"9b7fbb7d","295":"4fb5296a","303":"f757d45e","453":"d855a71b","510":"63d488a1","593":"9173fd64","675":"a645f6f1","875":"afaf68c4","908":"9e3de99d"}[chunkId] + ".chunk.js";
};